import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { MessageListScrollContainer } from './styles';
const ListScroller = ({ children, isAutoScrollEnabled = false, }) => {
    const messagesRef = useRef(null);
    const [autoScroll, setAutoScroll] = useState(isAutoScrollEnabled);
    useEffect(() => {
        setAutoScroll(isAutoScrollEnabled);
    }, [isAutoScrollEnabled]);
    useEffect(() => {
        if (isAutoScrollEnabled && autoScroll && messagesRef.current) {
            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
        }
    }, [children, autoScroll, isAutoScrollEnabled]);
    const handleScroll = () => {
        const container = messagesRef.current;
        if (!container)
            return;
        const isAtBottom = container.scrollHeight - container.scrollTop <=
            container.clientHeight + 20;
        setAutoScroll(isAtBottom);
    };
    return (_jsx(MessageListScrollContainer, { ref: messagesRef, onScroll: handleScroll, children: children }));
};
export default ListScroller;
